/* istanbul ignore file */
import AdditionalInformationForm from './AdditionalInformationForm';

export default AdditionalInformationForm;
